export default function getUnsubsctibeAlertNotificationUrl(alertId: string, emailAddress: string, token: string) {
  return `/v1/notifications/alert/${alertId}/recipient/${emailAddress}/unsubscribe/${token}`;
}
